<template>
  <Teleport to="body">
    <Drawer
      :title="`Edit Details — Invoice #${invoice.invoice_id}`"
      @hide-drawer="onHide"
    >
      <InvoiceDetails
        ref="detailsRef"
        :invoice="invoice"
        @choose-guarantor="onChooseGuarantor"
      />
      <template #footer>
        <div class="flex gap-3 w-full">
          <Button
            label="Cancel"
            type="Secondary"
            class="flex-1"
            @click="close"
          />
          <Button
            label="Save"
            type="Primary"
            class="flex-1"
            :disabled="saving"
            @click="onSave"
          />
        </div>
      </template>
    </Drawer>
  </Teleport>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { EventBus } from "@/lib/event_bus";

import Button from "@/components/Seranova/Buttons/Button.vue";
import Drawer from "@/components/Seranova/Drawer/Drawer.vue";
import type { Invoice } from "@/typings/invoice";
import InvoiceDetails from "./InvoiceDetails.vue";

defineProps<{
  invoice: Invoice;
}>();

const emit = defineEmits<{
  "hide-drawer": [];
}>();

const detailsRef = ref<InstanceType<typeof InvoiceDetails> | null>(null);
const saving = ref(false);

const close = () => {
  removeBackdrop();
  emit("hide-drawer");
};

const onHide = () => {
  removeBackdrop();
  emit("hide-drawer");
};

const onSave = async () => {
  saving.value = true;
  try {
    await detailsRef.value?.save();
    window.notify.success("Invoice details updated successfully");
    close();
  } catch {
    window.notify.error("Failed to update invoice details");
  } finally {
    saving.value = false;
  }
};

const onChooseGuarantor = () => {
  close();
  EventBus.$emit("choose-guarantor");
};

const removeBackdrop = () => {
  document.querySelectorAll("[drawer-backdrop]").forEach((el) => el.remove());
};
</script>
